import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';
import React, { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}
export const EditPaymentsContainer = ({ children, isOpen, onClose }: Props) => {
  const intl = useIntl();

  return (
    <Sidebar
      open={isOpen}
      onCancel={onClose}
      aria-label={intl.formatMessage({
        id: 'predict.predictions.edit_payment_dates',
        defaultMessage: 'Edit payment dates'
      })}
      header={
        <Typography variant="h2" fontWeight="700">
          <FormattedMessage id="predict.predictions.edit_payment_dates" defaultMessage="Edit payment dates" />
        </Typography>
      }
      size="medium-large"
    >
      {children}
    </Sidebar>
  );
};
